// extracted by mini-css-extract-plugin
export default {"dragPreview":"TableOptionsColumnDragPreview-dragPreview-rMhuQ"};